// extracted by mini-css-extract-plugin
module.exports = {"storeBtnItem":"Market_storeBtnItem__b-P_d"};